module.exports = __webpack_public_path__ + "static/media/welcome.dc3bd9b8.svg";